// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fc1c7233","404":"811acf01","498":"a30a7d63","787":"e7e4e8fa"}[chunkId] + ".chunk.js";
};